<template>
  <div class="container mx-auto app-content-back h-screen p-2">
    <h1 class="mb-4">
      Heute
    </h1>

    <div v-if="sessions && sessions.length >0">
      <div>
        <div
          v-for="item in sessions"
          :key="item.sessionId"
        >
          <span class="font-bold">{{ item.teamName }}</span> {{ item.title }}
          <sc-presence-members
            :session-id="item.sessionId"
            :members="item.teamMembers"
            :player-reviews="item.playerReviews"
          />
        </div>
      </div>
    </div>

    <div v-if="!sessions ||sessions.length<=0">
      Keine Trainings heute
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'Today',
    data () {
        return {
            sessions: null,
            timer: null
        }
    },
    async mounted () {
        await this.getTodayData()

        this.timer = setInterval(this.getTodayData, 20 * 60 * 1000)
    },
    methods: {
        async getTodayData () {
            const response = await apiService.getMySessionsToday()
            this.sessions = response.data
        }
    }
}
</script>

<style scoped>

</style>
